import {
  FETCH_DELETE_TEMPLATE_REQUEST,
  FETCH_DELETE_TEMPLATE_SUCCESS,
  FETCH_DELETE_TEMPLATE_FALUIRE,
} from './deleteTemplateTypes'

const initialState = {
  loading: false,
  deletedTemplateInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_TEMPLATE_SUCCESS : return {
      ...state,
      deletedTemplateInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      deletedTemplateInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
